import { render, staticRenderFns } from "./PosisiSaldo.vue?vue&type=template&id=2faa247a"
import script from "./PosisiSaldo.vue?vue&type=script&lang=js"
export * from "./PosisiSaldo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports